<template>
  <span :class="['px-3 py-1.5 text-xs font-semibold rounded-full border', colorClass]">
    {{ displayValue }}
  </span>
</template>

<script>
const BADGE_COLORS = {
  success: 'bg-green-100 text-green-800 border-green-300',
  warning: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  danger: 'bg-red-100 text-red-800 border-red-300',
  info: 'bg-blue-100 text-blue-800 border-blue-300',
  special: 'bg-purple-100 text-purple-800 border-purple-300',
  neutral: 'bg-gray-100 text-gray-800 border-gray-300',
}

export default {
  name: 'CellStatusBadge',
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  computed: {
    variant() {
      return this.params.variant || 'call'
    },
    displayValue() {
      if (this.params.valueTransform) {
        return this.params.valueTransform(this.params.value)
      }
      return this.params.value
    },
    colorClass() {
      const statusLower = (this.params.value || '').toLowerCase()

      if (this.variant === 'call-config') {
        const configColors = {
          published: BADGE_COLORS.success,
          draft: BADGE_COLORS.warning,
          archived: BADGE_COLORS.neutral,
        }
        return configColors[statusLower] || BADGE_COLORS.neutral
      }

      if (this.variant === 'call') {
        const callColors = {
          completed: BADGE_COLORS.success,
          in_progress: BADGE_COLORS.info,
          'in progress': BADGE_COLORS.info,
          ringing: BADGE_COLORS.info,
          pending: BADGE_COLORS.warning,
          failed: BADGE_COLORS.danger,
          no_answer: BADGE_COLORS.neutral,
          'no answer': BADGE_COLORS.neutral,
          busy: BADGE_COLORS.neutral,
        }
        return callColors[statusLower] || BADGE_COLORS.neutral
      }

      if (this.variant === 'tts-provider') {
        const ttsColors = {
          cartesia: BADGE_COLORS.info,
          openai: BADGE_COLORS.special,
        }
        return ttsColors[statusLower] || BADGE_COLORS.neutral
      }

      return BADGE_COLORS.neutral
    },
  },
}
</script>
